import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import LinkedInCommunity from '../assets/LinkedInCommunity.png';
import DiscordCommunity from '../assets/DiscordCommunity.png';
import CeroLogoLarge from '../assets/CeroLogoLarge.png';
import ChromeIcon from '../assets/chromeIcon.svg';
import DiscordIcon from '../assets/Discord.svg';

export const CommunitySection: React.FC = () => {
  return (
    <>
      <style>{`
        .community-cta {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: min(100%, 786px);
        }

        .community-cta__logo {
          width: 200px;
          height: 200px;
          object-fit: contain;
        }

        .community-cta__content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 96px;
          width: 100%;
          margin-top: 50px;
        }

        .community-cta__headline {
          margin: 0;
          font-family: Inter, sans-serif;
          font-weight: 500;
          font-size: clamp(36px, 5vw, 64px);
          line-height: clamp(48px, 6.67vw, 96px);
          letter-spacing: -0.72px;
          text-align: center;
        }

        .community-cta__headline-muted {
          color: rgba(255, 255, 255, 0.64);
        }

        .community-cta__headline-accent {
          color: #ffffff;
        }

        .community-cta__buttons {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          gap: 24px;
          margin-bottom: 90px;
          width: 100%;
        }

        .community-cta__btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          height: 56px;
          border-radius: 14px;
          border: 1.5px solid;
          color: #ffffff;
          font-family: Inter, sans-serif;
          font-size: 20px;
          font-weight: 500;
          line-height: normal;
          text-decoration: none;
          box-sizing: border-box;
          white-space: nowrap;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          transition: background-color 0.15s ease-in-out;
        }

        .community-cta__btn:hover,
        .community-cta__btn:focus-visible {
          color: #ffffff;
          text-decoration: none;
        }

        .community-cta__btn--chrome {
          gap: 8px;
          width: 229px;
          max-width: 100%;
          padding: 20.5px 28px 20.5px 24px;
          border-color: rgba(255, 128, 0, 0.72);
          background: rgba(255, 128, 0, 0.16);
          box-shadow: inset 0px 0px 24px 0px rgba(255, 128, 0, 0.24);
        }

        .community-cta__btn--chrome:hover,
        .community-cta__btn--chrome:focus-visible {
          background: rgba(255, 128, 0, 0.24);
        }

        .community-cta__btn--discord {
          gap: 10px;
          padding: 19px 28px;
          border-color: rgba(255, 128, 0, 0.42);
          background: rgba(255, 128, 0, 0.04);
          box-shadow: inset 0px 0px 16px 0px rgba(255, 128, 0, 0.22);
        }

        .community-cta__btn--discord:hover,
        .community-cta__btn--discord:focus-visible {
          background: rgba(255, 128, 0, 0.1);
        }

        .community-cta__btn:focus-visible {
          outline: 2px solid rgba(255, 128, 0, 0.5);
          outline-offset: 2px;
        }

        .community-cta__chrome-icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        .community-cta__discord-icon {
          width: 20.645px;
          height: 16px;
          flex-shrink: 0;
        }

        @media (max-width: 575.98px) {
          .community-cta__logo {
            width: 120px;
            height: 120px;
          }

          .community-cta__content {
            gap: 48px;
            margin-top: 48px;
          }

          .community-cta__headline {
            font-size: 26px;
            line-height: 38px;
          }

          .community-cta__buttons {
            flex-direction: column;
            align-items: stretch;
            width: fit-content;
            max-width: 100%;
          }

          .community-cta__btn--chrome,
          .community-cta__btn--discord {
            width: 100%;
            min-width: 0;
            padding: 19px 28px;
          }
        }
      `}</style>
    <Container
      id="community"
      fluid
      className="d-flex flex-column align-items-center"
      style={{ paddingTop: 80, paddingBottom: 120, marginBottom: 60 }}
    >
      <Row className="w-100 justify-content-center">
        <Col
          xs={12}
          md={10}
          lg={9}
          xl={8}
          className="d-flex flex-column align-items-center text-center"
          style={{ gap: 16 }}
        >
          <div
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 50,
              lineHeight: '100%',
              letterSpacing: '-2%',
              color: '#FFFFFF',
            }}
          >
            Join a thriving community
          </div>
          <div
            style={{
              marginTop: 12,
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: 20,
              lineHeight: '32px',
              color: '#FFFFFF6B',
              maxWidth: 900,
            }}
          >
            Cero is not just your All-in-One Personal Branding Tool, but it’s your
            <br />
            All-in-One Personal Branding Solution Academy.
          </div>
        </Col>
      </Row>

      <Row className="w-100 justify-content-center" style={{ marginTop: 90 }}>
        <Col xs={12} className="d-flex justify-content-center">
          <div style={{ width: '80%' }}>
            <Row className="g-3">
              <Col xs={12} md={6} className="d-flex justify-content-center">
                <a
                  href="#"
                  className="d-inline-block"
                  style={{ cursor: 'pointer' }}
                  aria-label="Join our LinkedIn community"
                >
                  <Image
                    src={LinkedInCommunity}
                    alt="LinkedIn community"
                    className="img-fluid"
                    style={{ borderRadius: 16 }}
                  />
                </a>
              </Col>
              <Col xs={12} md={6} className="d-flex justify-content-center">
                <a
                  href="#"
                  className="d-inline-block"
                  style={{ cursor: 'pointer' }}
                  aria-label="Join our Discord community"
                >
                  <Image
                    src={DiscordCommunity}
                    alt="Discord community"
                    className="img-fluid"
                    style={{ borderRadius: 16 }}
                  />
                </a>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Row className="w-100 justify-content-center" style={{ marginTop: 120 }}>
        <Col xs={12} className="d-flex justify-content-center">
          <div className="community-cta">
            <Image src={CeroLogoLarge} alt="Cero" className="community-cta__logo" />

            <div className="community-cta__content">
              <h2 className="community-cta__headline">
                <span className="community-cta__headline-muted">Generate Viral LinkedIn</span>
                <br />
                <span className="community-cta__headline-accent">Posts </span>
                <span className="community-cta__headline-muted">in</span>
                <span className="community-cta__headline-accent"> Seconds</span>
              </h2>

              <div className="community-cta__buttons">
                <a
                  href="https://chromewebstore.google.com/detail/cero-linkedin-personal-br/moeocagahkkomhnekdhlfjbmomkjoddj?hl=en"
                  className="community-cta__btn community-cta__btn--chrome"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image src={ChromeIcon} alt="" className="community-cta__chrome-icon" />
                  <span>Add to Chrome</span>
                </a>

                <a href="#" className="community-cta__btn community-cta__btn--discord">
                  <Image src={DiscordIcon} alt="" className="community-cta__discord-icon" />
                  <span>Join Discord</span>
                </a>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
    </>
  );
};
